<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
@if (
  (isBannerVisible$ | async) &&
  (headerContent$ | async)?.showPromoBanner &&
  !isDisabledRoute()
) {
  <div
    [@fadeInOut]
    class="bg-[#776B62] flex flex-row items-center py-[10px] lg:py-[14px] justify-center relative"
  >
    <div class="md:basis-1/6"></div>
    @if (headerContent$ | async; as headerContent) {
      <div class="flex flex-row justify-center items-center m-auto flex-1">
        <p
          class="ml-4 lg:ml-10 text-[15px] lg:text-[17px] leading-5 lg:leading-[30px]"
        >
          {{ headerContent?.promoBannerMessage }}
        </p>
        @if (headerContent?.promoBannerUrl?.startsWith('http')) {
          <a
            [href]="
              headerContent?.promoBannerPage?.url ??
              headerContent?.promoBannerUrl
            "
            class="flex max-h-11"
            target="_blank"
          >
            <ss-button
              class="ml-2 lg:ml-6 max-h-11 my-auto mr-3 lg:mr-4"
              buttonColor="principal"
              buttonStyle="filled"
              >{{ headerContent?.buttonText }}</ss-button
            >
          </a>
        } @else {
          @if (
            headerContent?.buttonText &&
            (headerContent?.promoBannerPage || headerContent?.promoBannerUrl)
          ) {
            <ss-button
              class="ml-2 lg:ml-6 max-h-11 my-auto mr-3 lg:mr-4"
              buttonColor="principal"
              buttonStyle="filled"
              [routerLink]="[
                headerContent?.promoBannerPage?.url ??
                  headerContent?.promoBannerUrl,
              ]"
              >{{ headerContent?.buttonText }}</ss-button
            >
          }
        }
      </div>
    }
    <div class="md:basis-1/6 flex justify-end">
      <button
        class="mr-4 lg:mr-32 shrink-0"
        (click)="dispatchSetDismissPromoBanner()"
      >
        <img
          class="w-7"
          src="/assets/icons/close-banner-button.svg"
          alt="cart"
        />
      </button>
    </div>
    <div
      class="absolute bottom-0 left-0 right-0 h-[1px] bg-gradient-to-r from-ss-gold to-[#7e5e2f]"
    ></div>
  </div>
}
